import { WorkshopTabsTable } from 'pages/Workshop/components/WorkshopTabsTable';
import { Fragment, useEffect, useState } from 'react';
import { ShowMoreButton } from '../ShowMoreButton';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAllPaginatedFormProcessEffect,
  updateAllFormProcessEffect,
} from 'store/effects/formProcess';
import { addProOrTransFilterParam } from 'utils/aggregatedPageTypeHelper';
import { getAggregatePageTypeSelector } from 'store/selectors/workshop';
import {
  getAllFormProcessesSelector,
  getFormsColumnSortSelector,
  getFormsFiltersSelector,
} from 'store/selectors/requestFormProcess';
import { FormKeysByStatus } from 'app-constants';
import { formsFilters } from 'settings/constants/roles';
import { getProjectFilterSelector } from 'store/selectors/transactions';

type FormPaginatedTableWrapperType = {
  emptyText: string;
  dataSource: any;
  formStatus?: string;
  tableProps: any;
  totalPages: any;
  collapsibleProps?: any;
  isFiltersApplied?: boolean;
};
export const FormPaginatedTableWrapper = ({
  emptyText,
  dataSource,
  formStatus,
  tableProps,
  totalPages,
  collapsibleProps = {},
  isFiltersApplied,
}: FormPaginatedTableWrapperType) => {
  const [page, setPage] = useState(1);
  const [paginatedData, setPaginatedData] = useState(dataSource);

  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const { search, columnSorter: sortFilter, ...restFilters } = useSelector(getFormsFiltersSelector);
  const aggregatedPageType = useSelector(getAggregatePageTypeSelector);
  const formCategoryFilter = useSelector(getProjectFilterSelector);
  const formsColumnSort = useSelector(getFormsColumnSortSelector);

  const allFormProcess = useSelector(getAllFormProcessesSelector);

  const columnSorter = formStatus ? formsColumnSort[formStatus] || sortFilter : sortFilter;

  useEffect(() => {
    setPaginatedData(dataSource);
    setLoading(false);
  }, [dataSource]);

  const onFecthMoreForms = () => {
    let filters = restFilters;
    const newPage = page + 1;

    setLoading(true);

    dispatch(
      getAllPaginatedFormProcessEffect(
        {
          filters: {
            ...addProOrTransFilterParam(aggregatedPageType, {
              ...(filters && filters),
              ...(formStatus && { statuses: [formStatus] }),
              ...(search && { forms: [search] }),
              ...(columnSorter && columnSorter),
              scope: formCategoryFilter === formsFilters.myForms ? 'personal' : 'all',
              page: newPage,
            }),
          },
        },
        { silent: true },
        (error, response) => {
          if (!error) {
            const { data } = response.data.value;
            let updatedFormProcess = { data: {} };

            if (data.waitingOnOthersForms) {
              data.waitingOnOtherForms = data.waitingOnOthersForms;
              delete data.waitingOnOthersForms;
            }

            if (isFiltersApplied) {
              let updatedProcessData = { ...allFormProcess };
              if (filters.statuses) {
                Object.keys(data).forEach((formKey) => {
                  updatedProcessData[formKey] = [...updatedProcessData[formKey], ...data[formKey]];
                });
              }

              updatedFormProcess.data = { ...updatedProcessData };
            } else if (formStatus) {
              let formKey = FormKeysByStatus[formStatus];
              let dataKey = Object.keys(data)[0];

              updatedFormProcess.data = {
                ...allFormProcess,
                [formKey]: [...allFormProcess[formKey], ...data[dataKey]],
              };
            }

            setPage(newPage);
            dispatch(updateAllFormProcessEffect(updatedFormProcess));
          }
        },
      ),
    );
  };

  const hasMoreForms = paginatedData.length < totalPages;

  return (
    <Fragment>
      <WorkshopTabsTable
        dataSource={paginatedData}
        emptyText={emptyText}
        {...tableProps(totalPages > 0 && !isFiltersApplied ? paginatedData?.[0]?.status : '')}
        {...collapsibleProps}
        showLoaderInTable
      />

      {hasMoreForms && !collapsibleProps.loading && (
        <ShowMoreButton loading={loading} onClick={onFecthMoreForms} text="Show More" />
      )}
    </Fragment>
  );
};
